import { dew as _AbstractMergeDateTimeRefinerDew } from "../../../common/refiners/AbstractMergeDateTimeRefiner";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const AbstractMergeDateTimeRefiner_1 = __importDefault(_AbstractMergeDateTimeRefinerDew());
  class DEMergeDateTimeRefiner extends AbstractMergeDateTimeRefiner_1.default {
    patternBetween() {
      return new RegExp("^\\s*(T|um|am|,|-)?\\s*$");
    }
  }
  exports.default = DEMergeDateTimeRefiner;
  //# sourceMappingURL=DEMergeDateTimeRefiner.js.map
  return exports;
}